import React from 'react';
import Anchor from '../objects/Anchor';
import Avatar from '../objects/Avatar';
import UserName from '../objects/UserName';
import UserHeadline from '../objects/UserHeadline';
import StarLevel from '../objects/StarLevel';
import  { getProfile }  from '../../../../client/helpers/requests';
import Loader from '../../../../../src/client/components/common/elements/Loader';
import { connect } from 'react-redux';
class profileSummary extends React.Component {

    state = {
        profile: null,
        picture: null
    }

    getProfileData = () => {

        const personId = localStorage.getItem('person_id', false);
        
        getProfile( personId ).then( result => this.setState( { profile: result } ))

        const picturePath = new Request (`https://s3.intouchnetworks.com/getImage.php?id=${ personId }`);

        fetch(picturePath)
        .then( response  => response.text() )
        .then( url => this.setState( { picture: url } ))

    }

    componentWillMount(){
        this.getProfileData();
    }

    componentWillUpdate( nextProps) {
        if (this.props.profile.url !== nextProps.profile.url) {
            this.getProfileData();
        }
    }

    render() {
        const {profile} = this.state, picture = this.state.picture;
        const first = profile && profile.data.first_name,
              last = profile && profile.data.last_name,
		      fullName = first + ' ' + last,
              headline = profile && profile.data.profile_common.headline;
              
        if (!profile) return <Loader />
            
            return (
                <div className="profile-summary">
                    <div className="side-profile">
                        <Anchor internal path={'/profile'} anchorClass={'side-profile-link'}>
                            <Avatar avatarClass={'side-profile-image'}  userImage={picture} />
                        </Anchor>
                        <div className="side-profile-message">
                            <UserName nameClass={'message-name'} name={fullName}/>
                            <UserHeadline headlineClass={'message-info'} headline={headline}/>
                        </div>
                    </div>

                    <div className="side-star">
                        <StarLevel />
                        <p className="body-copy">To find out more about your stars <Anchor internal path={'/stars'} anchorClass={'clickable'}>click here</Anchor></p>
                    </div>
                </div>
            )
        }
};

const mapStateToProps = ( state ) => {
        return {
            profile: state.profile.picture,
        }
}

export default connect( mapStateToProps ) ( profileSummary );



// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/ProfileSummary.js